import React from 'react';
import { BuyNowButton, } from '../BuyNowButton';
import { useProduct } from '../ProductProvider';
/**
 * The `SelectedVariantBuyNowButton` component renders a `BuyNowButton` for the product's selected variant.
 * Clicking this button automatically adds the selected variant to the cart and redirect the customer to checkout.
 * It must be a descendent of a `ProductProvider` component.
 */
export function SelectedVariantBuyNowButton(props) {
    var _a, _b;
    const product = useProduct();
    if (product == null) {
        throw new Error('Expected a Product context, but none was found');
    }
    const { children, quantity, attributes, ...passthroughProps } = props;
    return (React.createElement(BuyNowButton, { quantity: quantity !== null && quantity !== void 0 ? quantity : 1, attributes: attributes, variantId: (_b = (_a = product.selectedVariant) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '', disabled: !product.selectedVariant || passthroughProps.disabled, ...passthroughProps }, children));
}
